import axios from "axios";

const SEGMENT_URL = "api/system/segments";

export const getSegmentTitles = () => {
  return axios.get(SEGMENT_URL);
};

export const changeSegmentTitles = ({
  segment1_vendor,
  segment2_vendor,
  segment3_vendor,
  segment1_buyer,
  segment2_buyer,
  segment3_buyer,
}: {
  segment1_vendor: string;
  segment2_vendor: string;
  segment3_vendor: string;
  segment1_buyer: string;
  segment2_buyer: string;
  segment3_buyer: string;
}) => {
  return axios.post(SEGMENT_URL, [
    { name: "segment1_vendor", text: segment1_vendor },
    { name: "segment2_vendor", text: segment2_vendor },
    { name: "segment3_vendor", text: segment3_vendor },
    { name: "segment1_buyer", text: segment1_buyer },
    { name: "segment2_buyer", text: segment2_buyer },
    { name: "segment3_buyer", text: segment3_buyer },
  ]);
};
